const translations = {
  // Navbar
  nav_home: 'Home',
  nav_about: 'About Us',
  nav_electrical: 'Electrical',
  nav_construction: 'Construction',
  nav_projects: 'Projects',
  nav_contact: 'Contact',
  nav_quote: 'Get a Quote',

  // Hero
  hero_slide1_tag: 'Electrical Engineering',
  hero_slide1_title: "Powering Türkiye's Leading Industrial Facilities",
  hero_slide1_subtitle: 'We provide turnkey solutions in medium and low voltage systems, weak current, and industrial automation.',
  hero_slide2_tag: 'Turnkey Pharma Facilities',
  hero_slide2_title: 'GMP-Compliant Applications Tailored for Pharmaceutical Facilities',
  hero_slide2_subtitle: 'With 30 years of experience, we implement fully compliant electrical and automation systems in pharmaceutical production facilities.',
  hero_slide3_tag: 'Defense & Pharma',
  hero_slide3_title: 'With TAI, Aselsan and\nAbdi İbrahim References',
  hero_slide3_subtitle: 'Leveraging field experience acquired at the sector\'s foremost industrial organizations, we reliably execute electrical infrastructure solutions for industrial facilities.',
  hero_cta_projects: 'View Our Projects',
  hero_cta_contact: 'Contact Us',

  // Stats
  stats_years: 'Years of Experience',
  stats_area: 'Projects Completed',
  stats_projects: 'Successful Projects',
  stats_engineers: 'Number of Employees',

  // Services
  services_label: 'What We Do',
  services_title: 'Comprehensive Engineering Solutions',
  services_desc: "From low voltage electrical systems to complete turnkey construction, we deliver end-to-end engineering solutions for Türkiye's most demanding industries.",
  services_electrical_title: 'Electrical Services',
  services_construction_title: 'Construction Services',
  services_view_all: 'View All',
  svc_mv_title: 'Medium Voltage Systems',
  svc_mv_desc: 'Power transmission lines, substation projects, switchgear systems, transformers, and distribution centers.',
  svc_lv_title: 'Low Voltage Systems',
  svc_lv_desc: 'Indoor/outdoor lighting, power installation, grounding (earthing), and UPS system installations.',
  svc_weak_title: 'Weak Current & Security',
  svc_weak_desc: 'Fire detection, CCTV, access control, intercoms, and public address systems.',
  svc_auto_title: 'Automation & Control',
  svc_auto_desc: 'Turnkey process automation, PLC-based systems, SCADA, and energy monitoring/management.',
  svc_rough_title: 'Rough Construction',
  svc_rough_desc: 'Foundation work, reinforced concrete, load-bearing systems, roofing, and facade applications.',
  svc_finish_title: 'Finishing & Architectural',
  svc_finish_desc: 'Interior finishing, flooring, painting, carpentry, and drywall partitions.',
  svc_ext_title: 'External Works',
  svc_ext_desc: 'Cladding, exterior insulation, and landscaping for complete project delivery.',
  svc_pm_title: 'Project Management',
  svc_pm_desc: 'Site surveys, cost analysis, scheduling, and full implementation coordination.',

  // Projects
  projects_label: 'Our Portfolio',
  projects_title: 'Featured Projects',
  projects_view_all: 'View All Projects',
  projects_cat_all: 'All',
  projects_cat_pharma: 'Pharmaceutical',
  projects_cat_defense: 'Defence Industry',
  projects_cat_infra: 'Infrastructure',
  projects_cat_health: 'Healthcare',
  projects_cat_industrial: 'Industrial Production',
  projects_cat_textile: 'Textile',
  projects_view_detail: 'View Details',
  projects_view_detail_btn: 'View Details',

  // About
  about_label: 'About Us',
  about_title: "Türkiye's Trusted EPC Partner Since 1996",
  about_p1: 'Canel Elektrik İnşaat Taahhüt Mühendislik is a leading Engineering, Procurement, and Construction (EPC) provider headquartered at Perpa Ticaret Merkezi, Istanbul. With nearly three decades of experience, we deliver comprehensive electrical contracting solutions for Türkiye\'s most critical and complex facilities.',
  about_p2: 'Our portfolio spans over 1,250,000 m² of completed projects across pharmaceuticals, defense industry, aerospace, healthcare, and industrial facilities — including landmark projects for Abdi İbrahim, TAI, and Aselsan.',
  about_cta: 'Learn More About Us',
  about_h1_title: 'ISO Certified',
  about_h1_desc: 'Quality management systems certified to international standards.',
  about_h2_title: 'Expert Team',
  about_h2_desc: 'Highly qualified engineers and project managers with decades of experience.',
  about_h3_title: '3D Modeling',
  about_h3_desc: 'Advanced 3D planning ensures precision before any work begins on site.',
  about_h4_title: 'As-Built Docs',
  about_h4_desc: 'Detailed as-built documentation delivered upon project completion.',
  about_industries_label: 'Industries We Serve',
  ind_pharma: 'Pharmaceutical',
  ind_defense: 'Defense',
  ind_aerospace: 'Aerospace',
  ind_health: 'Healthcare',
  ind_infra: 'Infrastructure',
  ind_industrial: 'Industrial',
  ind_hospitality: 'Hospitality',
  ind_education: 'Education',

  // Contact
  contact_label: 'Get In Touch',
  contact_title: "Let's Build Something Great Together",
  contact_desc: "Whether you need electrical engineering, turnkey construction, or specialized facility solutions — our team is ready to deliver.",
  contact_address_label: 'Address',
  contact_address_val: 'Perpa Ticaret Merkezi, A Blok Kat: 5 No: 204\nOkmeydanı, Şişli / Istanbul, Türkiye',
  contact_phone_label: 'Phone',
  contact_email_label: 'Email',

  // Navbar
  navbar_subtitle: 'Electrical & Construction',

  // About Page
  about_story_label: 'Our Story',
  about_story_title: '30+ Years of Engineering Legacy',
  about_timeline_label: 'History',
  about_timeline_title: 'Our Milestones',
  about_certs_label: 'Quality',
  about_certs_title: 'Our Certifications',
  about_team_label: 'Our Team',
  about_team_title: 'Leadership',
  cert_iso9001_desc: 'Quality Management System',
  cert_iso14001_desc: 'Environmental Management System',
  cert_iso45001_desc: 'Occupational Health & Safety',
  cert_tse_desc: 'Turkish Standards Institution',
  tl_1996_title: 'Founded',
  tl_1996_desc: 'Canel Elektrik was established in Istanbul.',
  tl_2007_title: 'Metro Project',
  tl_2007_desc: 'Sishane–Beyoglu metro infrastructure project successfully completed.',
  tl_2008_title: 'Defence Sector',
  tl_2008_desc: 'Defence industry projects launched with ASELSAN and TAI.',
  tl_2018_title: 'Biotechnology Project',
  tl_2018_desc: 'AbdiBio biotechnology facility project completed.',
  tl_2022_title: 'New Production Line Facility',
  tl_2022_desc: 'Abdi İbrahim New Production Line Facility (YUT) officially commenced operations.',
  tl_2026_title: '1,250,000+ m²',
  tl_2026_desc: 'Total completed project area exceeded 1,250,000 m².',
  about_refprojects_label: 'Projects',
  about_refprojects_title: 'Our Reference Projects',
  team_role_ceo: 'General Manager',
  team_role_elec: 'Electrical Project Manager',
  team_role_con: 'Construction Project Manager',
  team_role_auto: 'Automation Engineer',

  // Contact Page
  contact_hours_label: 'Working Hours',
  contact_hours_weekdays: 'Mon – Fri: 09:00 – 18:00',
  contact_hours_saturday: 'Saturday: 09:00 – 12:00',
  get_directions: 'Get Directions',

  // Electrical Page
  elec_hero_subtitle: 'Complete electrical engineering solutions from medium voltage to automation systems.',
  elec_detail_mv1: 'Power transmission lines',
  elec_detail_mv2: 'Substation projects',
  elec_detail_mv3: 'Switchgear systems',
  elec_detail_mv4: 'Transformers',
  elec_detail_mv5: 'Distribution centers',
  elec_detail_mv6: 'Compensation systems',
  elec_detail_lv1: 'Indoor/outdoor lighting',
  elec_detail_lv2: 'Power installation',
  elec_detail_lv3: 'Earthing systems',
  elec_detail_lv4: 'UPS installations',
  elec_detail_lv5: 'Panel manufacturing',
  elec_detail_lv6: 'Cable laying',
  elec_detail_weak1: 'Fire detection systems',
  elec_detail_weak2: 'CCTV & security cameras',
  elec_detail_weak3: 'Access control systems',
  elec_detail_weak4: 'Intercom systems',
  elec_detail_weak5: 'Public address systems',
  elec_detail_weak6: 'Structured cabling',
  elec_detail_auto1: 'Turnkey process automation',
  elec_detail_auto2: 'PLC-based control systems',
  elec_detail_auto3: 'SCADA systems',
  elec_detail_auto4: 'Energy monitoring & management',
  elec_detail_auto5: 'MCC panels',
  elec_detail_auto6: 'Field instrumentation',
  cta_title: 'Get a Quote for Your Project',
  cta_desc: 'Our expert team will evaluate your needs and offer the best solution.',

  // Construction Page
  con_hero_subtitle: 'Turnkey construction solutions from foundation to roof.',
  con_detail_rough1: 'Foundation excavation and concrete works',
  con_detail_rough2: 'Reinforced concrete load-bearing systems',
  con_detail_rough3: 'Steel construction',
  con_detail_rough4: 'Roofing systems',
  con_detail_rough5: 'Facade applications',
  con_detail_rough6: 'Waterproofing',
  con_detail_finish1: 'Interior finishing works',
  con_detail_finish2: 'Floor coverings',
  con_detail_finish3: 'Painting and plastering',
  con_detail_finish4: 'Carpentry works',
  con_detail_finish5: 'Drywall partitions',
  con_detail_finish6: 'Suspended ceiling systems',
  con_detail_ext1: 'Exterior facade cladding',
  con_detail_ext2: 'Thermal insulation',
  con_detail_ext3: 'Landscaping',
  con_detail_ext4: 'Roads and infrastructure',
  con_detail_ext5: 'Site arrangement',
  con_detail_ext6: 'Lighting',
  con_detail_pm1: 'Site survey and feasibility',
  con_detail_pm2: 'Cost analysis',
  con_detail_pm3: 'Work schedule preparation',
  con_detail_pm4: 'Quality control',
  con_detail_pm5: 'Reporting',
  con_detail_pm6: 'Handover and documentation',

  // Partners
  partners_label: 'Partners',
  partners_title: 'Our Solution Partners',

  // Footer
  footer_tagline: 'Engineering, Procurement & Construction. Istanbul, Türkiye. Est. 1996.',
  footer_services: 'SERVICES',
  footer_company: 'COMPANY',
  footer_contact: 'CONTACT',
  footer_about: 'About Us',
  footer_projects: 'Projects',
  footer_catalog: 'E-Catalog',
  footer_careers: 'Careers',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_copyright: '© 2024 Canel Elektrik İnşaat Taahhüt Mühendislik. All rights reserved.',
};

export default translations;
